import { render, staticRenderFns } from "./MilitaryCategoriesManager.vue?vue&type=template&id=54819030"
import script from "./MilitaryCategoriesManager.vue?vue&type=script&lang=js"
export * from "./MilitaryCategoriesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports